import { Grid, Icon, Card } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useEffect, useState } from "react";
import { get, postNoResponse } from "utils/WebService";
import BaseDeDadosCreateEdit from "../baseDeDados/BaseDeDadosCreateEdit";
import MDSnackbar from "components/MDSnackbar";

export default function FilaTrabalho() {
    const [filaItem, setFilaItem] = useState(null);
    const [loading, setLoading] = useState(true);
    const [successSB, setSuccessSB] = useState(false);
    const [errorSB, setErrorSB] = useState(false);
    const [sbMessage, setSbMessage] = useState("");
    const [isFilaConcluida, setIsFilaConcluida] = useState(false);

    const loadNextFicha = () => {
        setLoading(true);
        setIsFilaConcluida(false);
        setFilaItem(null);
        get("/fila-trabalho/proxima")
            .then((res) => {
                if (res && res.filaId) {
                    setFilaItem(res);
                } else {
                    setIsFilaConcluida(true);
                }
            })
            .catch(() => {
                setSbMessage("Erro ao carregar a próxima ficha da fila.");
                setErrorSB(true);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        loadNextFicha();
    }, []);

    const handleConcluir = async () => {
        if (!filaItem) return;
        
        try {
            await postNoResponse(`/fila-trabalho/concluir/${filaItem.filaId}`);
            setSbMessage("Ficha concluída com sucesso!");
            setSuccessSB(true);
            window.dispatchEvent(new Event("fila-trabalho-updated"));
            loadNextFicha();
        } catch (err) {
            console.error("Erro ao concluir ficha:", err);
            setSbMessage("Erro ao concluir a ficha.");
            setErrorSB(true);
        }
    };

    if (loading) {
        return (
            <MDBox display="flex" justifyContent="center" alignItems="center" height="80vh">
                <MDTypography variant="h5" color="text">Carregando Fila de Trabalho...</MDTypography>
            </MDBox>
        );
    }

    if (isFilaConcluida) {
        return (
            <MDBox display="flex" justifyContent="center" alignItems="center" height="80vh">
                <Card sx={{ p: 5, textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <Icon color="success" sx={{ fontSize: 80, mb: 2 }}>check_circle</Icon>
                    <MDTypography variant="h4" color="text">Fila Concluída!</MDTypography>
                    <MDTypography variant="body2" color="text" sx={{ mt: 1, mb: 3 }}>
                        Parabéns! Você não possui mais pendências na sua fila de trabalho.
                    </MDTypography>
                    <MDButton variant="contained" color="info" onClick={loadNextFicha}>
                        <Icon>refresh</Icon>&nbsp;Verificar Novamente
                    </MDButton>
                </Card>
            </MDBox>
        );
    }

    return (
        <Grid container display="flex" justifyContent="center">
            {filaItem && (
                <Grid item xs={12} md={12}>
                    <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                        <MDTypography variant="h5" fontWeight="medium">
                            Fila de Trabalho
                        </MDTypography>
                        <MDButton 
                            variant="gradient" 
                            color="success" 
                            size="large"
                            onClick={handleConcluir}
                        >
                            <Icon sx={{ fontWeight: "bold" }}>done_all</Icon>
                            &nbsp;CONCLUIR FICHA E IR PARA A PRÓXIMA
                        </MDButton>
                    </MDBox>

                    {/* Exibe o mesmo formulário de BaseDeDadosCreateEdit (Visualizar/Editar) */}
                    {/* isViewOnly={false} para permitir que ele adicione andamentos e edite o que for necessário */}
                    <BaseDeDadosCreateEdit 
                        recordId={filaItem.devedorId} 
                        idDevedorCarteira={filaItem.idDevedorCarteira}
                        closeCreateEdit={() => {}} 
                        isJuridico={false} 
                        isViewOnly={false} 
                        isFila={true}
                    />
                </Grid>
            )}

            <MDSnackbar
                color={successSB ? "success" : "error"}
                icon={successSB ? "check" : "warning"}
                title={successSB ? "Sucesso" : "Erro"}
                content={sbMessage}
                dateTime=""
                open={successSB || errorSB}
                onClose={() => {
                    setSuccessSB(false);
                    setErrorSB(false);
                }}
                close={() => {
                    setSuccessSB(false);
                    setErrorSB(false);
                }}
                bgWhite
            />
        </Grid>
    );
}
